import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../utils/enums';
import { LOGIN_STEP } from '../utils/enums';

/**
 * Custom hook to extract and process URL path information
 * @returns Object with route parameters and path construction utilities
 */
export const useRouteParams = () => {
  const location = useLocation();
  
  return useMemo(() => {
    const currentPath = location.pathname;
    const currentSource = currentPath.split("/")[1].toLowerCase();
    const step = currentPath.split("/")[2]?.toLowerCase();
    const child = currentPath.split("/")[3]?.toLowerCase();
    const prefix = `/${currentSource}/${step}/`.toLowerCase();
    const prefixChild = `${prefix}${child}`.toLowerCase();
    // Precomputed login paths
    const LOGIN_PATHS = {
      LOGIN_DETAILS: `${prefix}${ROUTES.LOGIN_DETAILS}`,
      LOGIN_OTP: `${prefix}${ROUTES.LOGIN_OTP}`,
      CHOOSE_POLICY: `${prefix}${ROUTES.LOGIN_CHOOSE_POLICY}`,
      UPDATE_CONTACT_DETAILS: `${prefix}${ROUTES.UPDATE_CONTACT_DETAILS}`,
      FULL_LOGIN_OTP: `/${currentSource}${LOGIN_STEP.OTP}`,
      PC_PLUS_SCREEN: `${prefix}${ROUTES.PC_PLUS_SCREEN}`,
    } as const;

    return {
      location,
      currentSource,
      step,
      child,
      prefix,
      prefixChild,
      LOGIN_PATHS,
      currentPath,
    };
  }, [location]);
}; 